import React from 'react';
import '../CSS/404.css';

export default HTTP404;

function HTTP404() {
	return(
		<>	
		<div className="fourofour">

			<div className="container">
		
					Whoops!
 <br/>
				Looks like you're trying to find a page that <b>doesn't exist</b>.<br/><br/>
				Perhaps you are looking for a page that has been moved?<br/>
			</div>
		</div>
		</>
	)	
}


